module.exports = __webpack_public_path__ + "img/test.ca346964.jpg";